import { IDeviceMinDto } from "src/app/devices/models/device"

export interface IBase {
    id: string,
    createdOn? : string,
    createdBy?: string
}

export interface IBaseSearchRequest {
  keyword?: string,
  pageNumber: number,
  pageSize: number,
  orderBy?: string[],
  advancedFilter?: IFilter,
  advancedSearch?: ISearch,
  scheduledDateFrom?: string,
  scheduledDateTo?: string,
  productKeyword?: string
}

export interface IBaseGetByComanyRequest {
  keyword?: string,
  pageNumber: number,
  pageSize: number,
  companyId: string,
  orderBy?: string[],
  advancedFilter?: IFilter,
  advancedSearch?: ISearch,
  scheduledDateFrom?: string,
  scheduledDateTo?: string,
  productKeyword?: string
}

export interface IBaseGetAvailableDevicesForInstallationRequest {
  keyword?: string,
  pageNumber: number,
  pageSize: number,
  companyId: string,
  installationId?: string,
  linkedDeviceIds?: string[],
  orderBy?: string[],
  advancedFilter?: IFilter,
  advancedSearch?: ISearch
}
export interface IBaseGetByDeviceRequest {
  keyword?: string,
  pageNumber: number,
  pageSize: number,
  deviceId: string,
  orderBy?: string[],
  advancedFilter?: IFilter,
  advancedSearch?: ISearch
}

export interface IBaseGetByCabinetRequest {
  keyword?: string,
  pageNumber: number,
  pageSize: number,
  cabinetId: string,
  orderBy?: string[],
  advancedFilter?: IFilter,
  advancedSearch?: ISearch
}

export interface IBaseGetByProductRequest {
  keyword?: string,
  pageNumber: number,
  pageSize: number,
  productId: string,
  tenantId: string,
  orderBy?: string[],
  advancedFilter?: IFilter,
  advancedSearch?: ISearch
}

export interface IBaseGetBySlotRequest {
  keyword?: string,
  pageNumber: number,
  pageSize: number,
  slotId: string,
  orderBy?: string[],
  advancedFilter?: IFilter,
  advancedSearch?: ISearch
}

export interface IBaseGetByRevisionRequest {
  keyword?: string,
  pageNumber: number,
  pageSize: number,
  revisionId: string,
  scheduledDateFrom?: string,
  scheduledDateTo?: string,
  serviceStatus?: number,
  orderBy?: string[],
  advancedFilter?: IFilter,
  advancedSearch?: ISearch
}

// operators
// EQ = equals
// NEQ = not equals
// LT = less than
// LTE = less than equals
// GT = greater than
// GTE = greater than equals
// STARTSWITH = startswith
// ENDSWITH = endswith
// CONTAINS = contains
export interface IFilter {
  logic?: "and" | "or" | "xor",
  filters?: IFilter[]
  field?: string,
  operator?: "eq" | "neq" | "lt" | "lte" | "gt" | "gte" | "startswith" | "endswith" | "contains",
  value?: string | boolean | number,
}


export interface ISearch{
  fields: string[],
  keyword: string
}

export interface IPagedResults<T> {
  data: T;
  currentPage: number;
  totalPages: number;
  totalCount: number;
  pageSize: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface IGridState {
  pageSize: number;
  skip: number;
}

export enum PageSize {
  Small = 25,
  Medium = 50,
  Large = 100,
}

export interface IPagedResults<T> {
  data: T;
  currentPage: number;
  totalPages: number;
  totalCount: number;
  pageSize: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface IGridResult<T> {
  data: T;
  total: number;
}